module.exports = __webpack_public_path__ + "media/Video 107.e933714f.mp4";